import React, { ReactElement } from "react";

function TreeIcon(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28.748"
      height="30"
      viewBox="0 0 28.748 30"
    >
      <g id="tree" transform="translate(-10.678 0)">
        <path
          id="Path_9987"
          data-name="Path 9987"
          d="M38.129,8.72a4.456,4.456,0,0,0,.05-.6A6.883,6.883,0,0,0,31.3,1.248a6.667,6.667,0,0,0-2.828.635A4.655,4.655,0,0,0,20.3,3.234a5.481,5.481,0,0,0-2.75-.736,5.625,5.625,0,0,0-5.625,5.625,5.466,5.466,0,0,0,.25,1.6,7.045,7.045,0,0,0-1.5,4.343,7.15,7.15,0,0,0,9.234,6.875l9.367.038a7.944,7.944,0,0,0,2.025.275A8.125,8.125,0,0,0,38.129,8.72Z"
          transform="translate(0)"
          fill="#68b030"
        />
        <path
          id="Path_9988"
          data-name="Path 9988"
          d="M95.731,84.2c-1.25-1.25-6.2-1.414-8.062-1.431a23.335,23.335,0,0,1-.518-7.384.625.625,0,0,0-1.055-.56c-1.393,1.393-3.239,7.372-3.778,9.193H75.287a.625.625,0,0,0-.2,1.219c.053.018,5.017,1.67,7,3.366a65.767,65.767,0,0,0,.075,11.119.625.625,0,0,0,.621.546h6.25a.625.625,0,0,0,.608-.771c-.661-2.744-2.335-10.022-2.474-12.112,1.525-1.461,5.127-2.118,8.117-2.118a.625.625,0,0,0,.442-1.068Z"
          transform="translate(-60.234 -70.267)"
          fill="#007a49"
        />
      </g>
    </svg>
  );
}

export default TreeIcon;
